import { cancelIfLate, createFileRequest, createJSONRequest, createPagedRequest } from '../../../api/create-request.js'
import querify from '../../../util/querify'

// ===== KNOWLEDGE BASE DATA =====
// Fetch data for knowledge base (legacy function)
// Accepted parameters: tags & query
export const fetchKnowledgeBaseData = cancelIfLate((parameters?: any) => createPagedRequest({
  method: 'GET',
  url: `/api/dashboards/knowledge?${querify(parameters || {})}`,
}))

export const buildExportContentLink = (parameters: any) => {
  return `/api/dashboards/knowledge?${querify(parameters)}`
}

// ===== CONTENT ACTIONS =====
export const acceptContent = (fileId: number) => createJSONRequest({
  url: `/api/files/${fileId}/accept`,
  method: 'PUT',
})

export const denyContent = (fileId: number) => createJSONRequest({
  url: `/api/files/${fileId}/deny`,
  method: 'PUT',
})

export const contentFeedback = (fileId: number, { feedback, dictionary_id }: { feedback: string; dictionary_id: number }) => createJSONRequest({
  url: `/api/files/${fileId}/feedback`,
  method: 'PUT',
  data: { feedback, dictionary_id },
})

export const annotateArticle = (id: number, conceptSearchId: number, bustCache = false) => createJSONRequest({
  method: 'GET',
  url: `/api/annotate/${id}?concept_search_id=${conceptSearchId}&bustCache=${bustCache}`,
})

export const trackArticle = (fileId: number, conceptSearchId: number, type: string) => createJSONRequest({
  method: 'PUT',
  url: `/api/files/${fileId}/track`,
  data: { conceptSearchId, type },
})

export const likeArticle = (fileId: number, status: boolean) => createJSONRequest({
  method: 'PUT',
  url: `/api/files/${fileId}/like`,
  data: { status },
})

// ===== KNOWLEDGE BASE CATEGORIES =====
// Categories are ecosystem-wide, not community-specific

export const fetchKnowledgeBaseCategories = () => createJSONRequest({
  method: 'GET',
  url: '/api/knowledge-base/categories',
})

export const fetchCategories = cancelIfLate(() => createJSONRequest({
  method: 'GET',
  url: '/api/knowledge-base/categories',
}))

export const createCategory = (categoryData: any) => createJSONRequest({
  method: 'POST',
  url: '/api/knowledge-base/categories',
  data: categoryData,
})

export const updateCategory = (categoryId: number, categoryData: any) => createJSONRequest({
  method: 'PUT',
  url: `/api/knowledge-base/categories/${categoryId}`,
  data: categoryData,
})

export const deleteCategory = (categoryId: number) => createJSONRequest({
  method: 'DELETE',
  url: `/api/knowledge-base/categories/${categoryId}`,
})

export const reorderCategories = (categoryIds: number[]) => createJSONRequest({
  method: 'POST',
  url: '/api/knowledge-base/categories/reorder',
  data: { order: categoryIds },
})

// ===== KNOWLEDGE BASE POSTS =====

interface PostParameters {
  communityId?: number
  per_page?: number
  bookmarked_only?: boolean
  category_id?: number

  [key: string]: any
}

export const fetchPosts = cancelIfLate((parameters: PostParameters = {}) => createPagedRequest({
  method: 'GET',
  url: `/api/knowledge-base/posts?${querify(parameters)}`,
}))

export const fetchPost = cancelIfLate((postId: number) => createJSONRequest({
  method: 'GET',
  url: `/api/knowledge-base/posts/${postId}`,
}))

// For backward compatibility - alias to fetchPost
export const getPost = fetchPost

export const updatePostCategory = (postId: number, categoryId: number | null) => createJSONRequest({
  method: 'PATCH',
  url: `/api/knowledge-base/posts/${postId}/category`,
  data: { knowledge_base_category_id: categoryId },
})

export const deletePost = (postId: number, communityId: number | null = null) => createJSONRequest({
  method: 'DELETE',
  url: `/api/knowledge-base/posts/${postId}`,
})

export const fetchPostsByCategory = cancelIfLate((parameters: PostParameters & { category_id: number }) => createPagedRequest({
  method: 'GET',
  url: `/api/knowledge-base/categories/${parameters.category_id}/posts?${querify(parameters)}`,
}))

export const fetchPostsByActor = cancelIfLate((actorId: string | number, parameters: PostParameters = {}) => createJSONRequest({
  method: 'GET',
  url: `/api/knowledge-base/actors/${actorId}/posts?${querify(parameters)}`,
}))

export const fetchUncategorizedPosts = cancelIfLate((parameters: PostParameters = {}) => createPagedRequest({
  method: 'GET',
  url: `/api/knowledge-base/posts/uncategorized?${querify(parameters)}`,
}))

interface SearchParameters {
  q: string
  bookmarked_only?: boolean
  communityId?: number

  [key: string]: any
}

export const searchPosts = cancelIfLate((parameters: SearchParameters) => createPagedRequest({
  method: 'GET',
  url: `/api/knowledge-base/posts/search?${querify(parameters)}`,
}))

// ===== KNOWLEDGE BASE BOOKMARKS =====

/*export const fetchBookmarks = cancelIfLate((parameters: PostParameters = {}) => createPagedRequest({
  method: 'GET',
  url: parameters.communityId ? `/api/communities/${parameters.communityId}/knowledge-base/bookmarks?${querify(parameters)}` : `/api/knowledge-base/bookmarks?${querify(parameters)}`,
}))

export const toggleBookmark = (postId: number) => createJSONRequest({
  method: 'POST',
  url: `/api/knowledge-base/posts/${postId}/bookmark`,
})

export const checkBookmark = cancelIfLate((postId: number, communityId: number | null = null) => createJSONRequest({
  method: 'GET',
  url: communityId ? `/api/communities/${communityId}/knowledge-base/posts/${postId}/bookmark/check` : `/api/knowledge-base/posts/${postId}/bookmark/check`,
}))

export const removeBookmark = (bookmarkId: number, communityId: number | null = null) => createJSONRequest({
  method: 'DELETE',
  url: communityId ? `/api/communities/${communityId}/knowledge-base/bookmarks/${bookmarkId}` : `/api/knowledge-base/bookmarks/${bookmarkId}`,
})*/

// ===== KNOWLEDGE BASE CURATION =====

/*export const fetchPendingPosts = cancelIfLate((parameters: PostParameters = {}) => createPagedRequest({
  method: 'GET',
  url: parameters.communityId ? `/api/communities/${parameters.communityId}/knowledge-base/posts/pending?${querify(parameters)}` : `/api/knowledge-base/posts/pending?${querify(parameters)}`,
}))*/

export const approvePost = (postId: number, communityId: number | null = null) => createJSONRequest({
  method: 'POST',
  url: `/api/knowledge-base/posts/${postId}/approve`,
})

export const rejectPost = (postId: number, communityId: number | null = null) => createJSONRequest({
  method: 'POST',
  url: `/api/knowledge-base/posts/${postId}/reject`,
})
